import React from 'react';
import { useParams } from 'react-router-dom';
import { TabbedPageTemplate } from './components/TabbedPageTemplate';
import { PathParams } from '../../../App';
import { MenuHeaderTemplate } from '../../../components/templates/MenuHeaderTemplate';

export const CouponPackMasterOverviewPage: React.FC = () => {
  const { couponPackMasterId } = useParams<PathParams>();

  return (
    <MenuHeaderTemplate
      header={{
        title: '回数券マスタ詳細',
        loading: undefined,
        progressLabel: undefined,
      }}
    >
      <TabbedPageTemplate couponPackMasterId={couponPackMasterId} />
    </MenuHeaderTemplate>
  );
};
